import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { STATES } from '../utils/use_game_state';
import useWindowSize from '../utils/use_window_size';

const Backdrop = ({ gameState, assetPath }) => {
  const windowSize = useWindowSize();
  const [y, setY] = useState(300);
  useEffect(() => {
    const width = windowSize.width;
    if (width <= 640) {
      setY(90);
    } else if (width <= 768) {
      setY(195);
    } else {
      setY(300);
    }
  }, [windowSize]);

  return <div className="w-full h-full absolute overflow-hidden" style={{ background: 'radial-gradient(190.53% 88.72% at 45.36% 100%, #BFDDF8 21.66%, #60A9F6 100%)' }}>
    <motion.div
      className="w-full h-full bg-no-repeat bg-bottom"
      animate={{ y: gameState >= STATES.INTRO ? y : 0 }}
      transition={{ duration: 2 }}
      style={{ backgroundImage: `url('${assetPath}assets/games/background.png')`, backgroundSize: '100% auto' }}
    />
  </div>;
}

export default Backdrop;
